export default [
    {
        path: "/account",
        name: "account",
        component: () => import("./Bind"),
        redirect: "/account/bind",
        children: [
            {
                path: "/account/bind",
                name: "bind",
                component: () => import("./Bind"),
                meta: {
                    title: "登录"
                }
            },
        ]
    },
    {
        path: "/account/forget/",
        name: "forget",
        component: () => import("./Forget"),
        meta: {
            title: "忘记密码"
        }
    },
]